<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>采购管理</el-breadcrumb-item>
                <el-breadcrumb-item>采购到货明细</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-form label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词">
                    <el-col>
                        <el-input v-model="query.keyword" prefix-icon="Search" placeholder="关键词"
                            @keyup.enter="fetchs()"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="质检状态">
                    <el-select v-model="qualityStatus" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="无质检" value="0"></el-option>
                        <el-option label="等待质检" value="1"></el-option>
                        <el-option label="质检通过" value="2"></el-option>
                        <el-option label="未通过" value="-1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库状态">
                    <el-select v-model="storeStatus" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="未入库" value="0"></el-option>
                        <el-option label="提交入库" value="1"></el-option>
                        <el-option label="已入库" value="2"></el-option>
                        <el-option label="取消入库" value="-1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="证书状态">
                    <el-select v-model="certStatus" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="无需证书" value="0"></el-option>
                        <el-option label="证书送检" value="1"></el-option>
                        <el-option label="证书通过" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="挂签状态">
                    <el-select v-model="tagStatus" clearable placeholder="请选择" @change="fetchs()"
                        style="min-width: 140px;">
                        <el-option label="无需挂签" value="0"></el-option>
                        <el-option label="待挂签" value="1"></el-option>
                        <el-option label="已挂签" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="search" @click="fetchs()">搜索</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-dropdown>
                <el-button plain type="primary">
                    <el-icon style="margin-right:5px;">
                        <Upload />
                    </el-icon>
                    数据操作
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="download()">导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:detailImg="scope">
                <el-image style="height: 32px; width: 32px" lazy
                    :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                    :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                    <template #error>
                        <img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" />
                    </template>
                </el-image>
            </template>

            <template v-slot:billCode="scope">
                <el-button link type="primary" @click="viewBill(scope.row)" size="small">{{ scope.row.billCode
                }}</el-button>
            </template>

            <template v-slot:qualityStatus="scope">
                <el-tag :type="getQualityStatusType(scope.row.qualityStatus)">
                    {{ getQualityStatusLabel(scope.row.qualityStatus) }}
                </el-tag>
            </template>

            <template v-slot:certStatus="scope">
                <el-tag :type="getCertStatusType(scope.row.certStatus)">
                    {{ getCertStatusLabel(scope.row.certStatus) }}
                </el-tag>
            </template>

            <template v-slot:tagStatus="scope">
                <el-tag :type="getTagStatusType(scope.row.tagStatus)">
                    {{ getTagStatusLabel(scope.row.tagStatus) }}
                </el-tag>
            </template>

            <template v-slot:storeStatus="scope">
                <el-tag :type="getStoreStatusType(scope.row.storeStatus)">
                    {{ getStoreStatusLabel(scope.row.storeStatus) }}
                </el-tag>
            </template>

            <template v-slot:status="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                    {{ getStatusLabel(scope.row.status) }}
                </el-tag>
            </template>

            <template v-slot:productionDate="scope">
                <span>{{ scope.row.productionDate ? $util.fmtDate(scope.row.productionDate, 'yyyy-MM-dd') : '' }}</span>
            </template>

            <template v-slot:expiryDate="scope">
                <span>{{ scope.row.expiryDate ? $util.fmtDate(scope.row.expiryDate, 'yyyy-MM-dd') : '' }}</span>
            </template>

            <template v-slot:toolbar="scope">
                <el-button @click="viewBill(scope.row)" link size="small" type="primary"
                    icon="Document">[查看单据]</el-button>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import BasicTable from '@/components/basic-table.vue'

export default {
    name: 'PurchaseDeliveryDetail',
    components: { BasicTable },
    data() {
        return {
            apiUrl: process.env.VUE_APP_BASEURL,
            query: {
                keyword: '',
                columns: [
                    { type: 'index', label: '序号', width: '60' },
                    { prop: 'detailImg', label: '图片', type: 'template', width: '60' },
                    { prop: 'billCode', label: '到货单号', type: 'template', sortable: true, searchable: true, width: '170' },
                    { prop: 'detailCode', label: '系统款号', sortable: true, searchable: true, width: '130' },
                    { prop: 'productCode', label: '货品编号', sortable: true, searchable: true, width: '120', showOverflowTooltip: true },

                    { prop: 'batchNo', label: '批次号', sortable: true, searchable: true, width: '120' },
                    { prop: 'serialCode', label: '序列号', sortable: true, searchable: true, width: '120' },

                    { prop: 'productName', label: '货品名称', sortable: true, searchable: true, width: '220', showOverflowTooltip: true },
                    { prop: 'productSpec', label: '规格型号', sortable: true, searchable: true, width: '150', showOverflowTooltip: true },
                    { prop: 'unitName', label: '单位', sortable: true, width: '70', showOverflowTooltip: true },
                    // { prop: 'suggestSupplierName', label: '供货工厂', sortable: true, searchable: true, width: '120', showOverflowTooltip: true },
                    // { prop: 'supplierProductCode', label: '工厂款号', sortable: true, searchable: true, width: '100', showOverflowTooltip: true },
                    // { prop: 'purchaseQuantity', label: '采购数', sortable: true, width: '80' },
                    { prop: 'deliveryQuantity', label: '到货数', sortable: true, width: '80' },
                    { prop: 'unitPrice', label: '单价', sortable: true, width: '80' },
                    { prop: 'amount', label: '金额', sortable: true, width: '80' },
                    { prop: 'taxRate', label: '税率(%)', sortable: true, width: '90' },
                    { prop: 'taxTotalAmount', label: '含税金额', sortable: true, width: '100' },
                    { prop: 'qualityStatus', label: '质检状态', type: 'template', sortable: true, width: '90', fixed: 'right' },
                    { prop: 'certStatus', label: '证书状态', type: 'template', sortable: true, width: '90', fixed: 'right' },
                    { prop: 'certNumber', label: '证书编号', sortable: true, searchable: true, width: '120' },
                    { prop: 'certRemark', label: '证书备注', width: '150', showOverflowTooltip: true },
                    { prop: 'tagBrand', label: '品牌名称', sortable: true, searchable: true, width: '90' },
                    { prop: 'tagStatus', label: '挂签入网', type: 'template', sortable: true, width: '90', fixed: 'right' },
                    { prop: 'tagNumber', label: '品牌编号', sortable: true, searchable: true, width: '120' },
                    { prop: 'tagRemark', label: '标签备注', width: '150', showOverflowTooltip: true },
                    { prop: 'storeStatus', label: '仓库状态', type: 'template', sortable: true, width: '90', fixed: 'right' },
                    { prop: 'storeCode', label: '收货仓库', sortable: true, searchable: true, width: '120' },
                    { prop: 'storeName', label: '仓库名称', sortable: true, searchable: true, width: '120' },
                    { prop: 'storeRemark', label: '仓库备注', width: '150', showOverflowTooltip: true },
                    { prop: 'productionDate', label: '生产日期', type: 'template', sortable: true, width: '110' },
                    { prop: 'expiryDate', label: '有效期至', type: 'template', sortable: true, width: '110' },
                    { prop: 'qualityRemark', label: '质检备注', width: '150', showOverflowTooltip: true },
                    { prop: 'inboundQuantity', label: '已入库数量', sortable: true, width: '120' },
                    { prop: 'remainQuantity', label: '剩余数量', sortable: true, width: '100' },
                    { prop: 'status', label: '状态', type: 'template', sortable: true, width: '90', fixed: 'right' },
                    { prop: 'remark', label: '备注', width: '200', showOverflowTooltip: true },
                    { type: 'toolbar', label: '操作', width: '140', fixed: 'right' },
                    { prop: 'billID', type: 'hidden' },
                ],
                filters: [],
                sidx: 'createDate',
                sord: 'desc'
            },
            qualityStatus: '',
            storeStatus: '',
            certStatus: '',
            tagStatus: ''
        }
    },
    mounted() {
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        // 质检状态
        getQualityStatusLabel(status) {
            const map = {
                0: '无质检',
                1: '等待质检',
                2: '质检通过',
                '-1': '未通过'
            };
            return map[status] || '无';
        },
        getQualityStatusType(status) {
            const map = {
                0: 'info',
                1: 'warning',
                2: 'success',
                '-1': 'danger'
            };
            return map[status] || 'info';
        },

        // 证书状态
        getCertStatusLabel(status) {
            const map = {
                0: '无需证书',
                1: '证书送检',
                2: '证书通过'
            };
            return map[status] || '无';
        },
        getCertStatusType(status) {
            const map = {
                0: 'info',
                1: 'warning',
                2: 'success'
            };
            return map[status] || 'info';
        },

        // 挂签状态
        getTagStatusLabel(status) {
            const map = {
                0: '无需挂签',
                1: '待挂签',
                2: '已挂签'
            };
            return map[status] || '无';
        },
        getTagStatusType(status) {
            const map = {
                0: 'info',
                1: 'warning',
                2: 'success'
            };
            return map[status] || 'info';
        },

        // 仓库状态
        getStoreStatusLabel(status) {
            const map = {
                0: '未入库',
                1: '提交入库',
                2: '已入库',
                '-1': '取消入库'
            };
            return map[status] || '无';
        },
        getStoreStatusType(status) {
            const map = {
                0: 'info',
                1: 'warning',
                2: 'success',
                '-1': 'danger'
            };
            return map[status] || 'info';
        },

        // 明细状态
        getStatusLabel(status) {
            const map = {
                0: '待确认',
                1: '已确认',
                2: '已入库',
                '-1': '已退货',
                '-2': '已返修'
            };
            return map[status] || '无';
        },
        getStatusType(status) {
            const map = {
                0: 'info',
                1: 'success',
                2: 'success',
                '-1': 'danger',
                '-2': 'warning'
            };
            return map[status] || 'info';
        },

        builder() {
            let { data, records, total, ...params } = { ...this.query };

            // 重置并添加筛选条件
            params.filters = [];
            if (this.qualityStatus !== '') {
                params.filters.push({ name: "qualityStatus", value: this.qualityStatus, operate: 0 });
            }
            if (this.storeStatus !== '') {
                params.filters.push({ name: "storeStatus", value: this.storeStatus, operate: 0 });
            }
            if (this.certStatus !== '') {
                params.filters.push({ name: "certStatus", value: this.certStatus, operate: 0 });
            }
            if (this.tagStatus !== '') {
                params.filters.push({ name: "tagStatus", value: this.tagStatus, operate: 0 });
            }
            return params;
        },

        fetchs() {
            this.$kaung.search(this.builder()).then(res => {
                this.query = { ...res.data }
            })
        },

        download() {
            this.$kaung.export(this.builder()).then(res => {
                const url = window.URL.createObjectURL(new Blob([res]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `采购到货明细_${this.$util.fmtDate(new Date(), 'yyyyMMddHHmmss')}.xlsx`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },

        viewBill(row) {
            if (row.billID) {
                // 跳转到到货单详情页面（查看模式）
                this.$router.push({
                    path: '/purchase/delivery/detail',
                    query: { id: row.billID }
                });
            } else {
                this.$message.warning('单据ID不存在');
            }
        }
    }
}
</script>

<style scoped>
.main-card {
    min-height: calc(100vh - 120px);
}

.search-form {
    margin-bottom: 20px;
}

.toolbar {
    margin-bottom: 15px;
}

.table {
    width: 100%;
}
</style>
